import { NgModule } from 'ng-metadata/core';
import { CommentComponent } from './comment.component';

@NgModule({
  declarations: [
    CommentComponent,
  ],
})
export class CommentModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/comment/comment.module.ts